import type { InferV1CreationTaskInfo, TaskInputPrompts } from '@/app/types';

export * from './blog';
export * from './calculate-total-transition-duration';
export * from './check-url-available';
export * from './cn';
export * from './community-utils';
export * from './convert-form';
export * from './convert-pro-text-prompt-to-simple';
export * from './convert-prompts-to-api';
export * from './coupon';
export * from './creation-detail-utils';
export * from './date-utils';
export * from './detect-image-type-by-buffer';
export * from './distribution-routes';
export * from './editor-text-prompt';
export * from './element-dialog-utils';
export * from './estimate-lip-sync-text-duration';
export * from './expected-server-fetch-error';
export * from './feed-detail';
export * from './format-aspect-ratio';
export * from './format-count';
export * from './format-duration-text';
export * from './format-price';
export * from './format-relative-time';
export * from './generate-from-page';
export * from './get-aspect-ratio';
export * from './get-audio-image-index';
export * from './get-audio-metadata';
export * from './get-byte-length';
export * from './get-cost-map-key';
export * from './get-default-recaption-prompt';
export * from './get-default-report-params';
export * from './get-feedback-url';
export * from './get-header-config';
export * from './get-image-ratio';
export * from './get-login-url';
export * from './get-max-image-and-element-count';
export * from './get-max-image-size';
export * from './get-mention-color';
export * from './get-product-status';
export * from './get-report-params';
export * from './get-resource-url';
export * from './get-subscription-url';
export * from './get-video-metadata';
export * from './hy-sdk';
export * from './image-utils';
export * from './impact-ref';
export * from './init-from-user-agent';
export * from './is-reference-asset-supported';
export * from './language';
export * from './link-navigation';
export * from './map-type-to-explore-tab';
export * from './masonry';
export * from './merge-creation-and-task';
export * from './metadata';
export * from './newbie-task-config';
export * from './node-converter';
export * from './pending-request-gate';
export * from './popup-login';
export * from './reference-count';
export * from './rename-image';
export * from './safe-storage';
export * from './sensor';
export * from './subs-plan';
export * from './sync-image-reference-prompts';
export * from './task-types';
export * from './team-space';
export * from './text-prompt-with-reference';
export * from './text2audio';
export * from './title-case-to-camel-case';
export * from './tools-form';
export * from './transition-sync';
export * from './validate-recaption-prompt';
export * from './validate-settings';
export * from './video-duration';
export * from './video-metadata-error';
export * from './voice-clone-reading-text';

export interface NestedMessages {
  [key: string]: string | NestedMessages;
}
type FlattenedMessages = Record<string, string>;

export const flattenMessages = (nestedMessages: NestedMessages, prefix = ''): FlattenedMessages => {
  return Object.keys(nestedMessages).reduce((messages: FlattenedMessages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else if (value) {
      // biome-ignore lint/performance/noAccumulatingSpread: <flatten-messages>
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }
    return messages;
  }, {});
};

/**
 * 生成文件名
 * @param type 文件类型
 * @param id 文件id
 * @returns 文件名
 */
export const generateFileName = ({ type, id }: { type: InferV1CreationTaskInfo['type']; id: string }) => {
  switch (type) {
    case 'audio':
      return `vidu-audio-${id}.wav`;
    case 'image':
      return `vidu-image-${id}.png`;
    default:
      return `vidu-video-${id}.mp4`;
  }
};

/**
 * 渲染 text2audio 的 prompt
 * @param p
 * @returns
 */
export const renderT2APrompt = (p: TaskInputPrompts) => {
  return p.timing_text ? `${p.timing_text?.from}s-${p.timing_text?.to}s:${p.content}` : p.content;
};

export const formatFileSize = (bytes: number, precision = 0) => {
  if (bytes === 0) return null;

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return `${(bytes / 1024 ** i).toFixed(precision)} ${sizes[i]}`;
};
